import Cleave from 'cleave.js/react'

export default Cleave
